import React, { PureComponent } from "react";
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Popover, PopoverBody } from "reactstrap";
import CheckIcon from "mdi-react/CheckIcon";
import PropTypes from "prop-types";
import uuid from "uuid";

class CheckBox extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool
  };

  render () {
    return (
      <label className="checkbox-btn profile__current-task-checkbox">
        <input
          className="checkbox-btn__checkbox"
          type="checkbox"
          checked={this.props.checked}
          onChange={this.props.handleChange}
        />
        <span className="checkbox-btn__checkbox-custom">
          <CheckIcon />
        </span>
      </label>
    );
  }
}

class PlaybookItem extends PureComponent {
  state = {
    titlePopoverOpen: false,
    rules: []
  };

  togglePopover = () => {
    this.setState({
      titlePopoverOpen: !this.state.titlePopoverOpen
    });
  };

  updatePlaybook (title, rule) {
    const updatedRules = this.state.rules.map(_rule => {
      //change the checked value
      if (_rule.title === rule.title) {
        _rule.checked = _rule.checked ? !_rule.checked : true;
      }
      return _rule;
    });

    this.setState({ rules: updatedRules });

    this.props.updatePlaybook(title, updatedRules);
  }

  componentDidMount () {
    if (this.props.rules) {
      this.setState({ rules: this.props.rules });
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props !== prevProps && this.props.rules) {
      this.setState({ rules: this.props.rules });
    }
  }

  render () {
    const { stepNumber, title, description } = this.props;

    return (
      <Col md={12}>
        <Card id="tour-playbook-item">
          <CardBody className="playbook">
            <div className="title-container">
              <span>
                <h4 className="step-number">{stepNumber}</h4>
              </span>
              <span className="step-title">{title}</span>
              {description && (
                <span
                  id={`title-${stepNumber}`}
                  className="title-popover-target"
                  onClick={this.togglePopover}
                >
                  {" "}
                  ?{" "}
                </span>
              )}
              {description && (
                <Popover
                  isOpen={this.state.titlePopoverOpen}
                  target={`title-${stepNumber}`}
                  placement="right"
                  toggle={this.togglePopover}
                  className="playbook-popover"
                >
                  <PopoverBody>{description}</PopoverBody>
                </Popover>
              )}
            </div>
            {this.state.rules
              ? this.state.rules.map(rule => {
                return (
                  <div key={uuid()} className="rule-container flex_display">
                    <CheckBox
                      checked={rule.checked}
                      handleChange={() => {
                        this.updatePlaybook(title, rule);
                      }}
                    />
                    <p>
                      <span>
                        {rule.title}
                        <span className="rule-description">
                          {rule.description.split("\n").map((item, key) => {
                            return (
                              <React.Fragment key={key}>
                                {item.replace(/\\n/g, "")}
                                <br />
                              </React.Fragment>
                            );
                          })}
                        </span>
                        {rule.resources && rule.resources.length > 0 ?
                          <span className='control-container'>
                            <span className='control-list'> Related Resource:&nbsp;
                            {rule.resources.map((resource, i) =>
                              <span key={uuid()} style={{ display: 'inline', marginLeft: 0 }}>{i > 0 && ", "}
                                {resource.url.indexOf("http") === 0 ? (
                                  <a href={`${resource.url}`}>
                                    {resource.text}
                                  </a>
                                ) : (
                                    <Link to={`${resource.url}`}>
                                      {" "}
                                      {resource.text}
                                    </Link>
                                  )}
                              </span>
                            )}
                            </span>
                          </span> : null
                        }
                        {rule.solutions && rule.solutions.length > 0 ?
                          <span className='control-container'>
                            <span className='control-list'> Related Solution:&nbsp;
                            {rule.solutions.map((solution, i) =>
                              <span key={uuid()} style={{ display: 'inline', marginLeft: 0 }}>{i > 0 && ", "}
                                {solution.url.indexOf("http") === 0 ? (
                                  <a href={`${solution.url}`}>
                                    {solution.text}
                                  </a>
                                ) : (
                                    <Link to={`${solution.url}`}>
                                      {" "}
                                      {solution.text}
                                    </Link>
                                  )}
                              </span>
                            )}
                            </span>
                          </span> : null
                        }
                      </span>
                    </p>
                  </div>
                );
              })
              : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default PlaybookItem;



// WEBPACK FOOTER //
// ./src/components/tour/playbook/components/playbookItem.js